import { render, staticRenderFns } from "./RomaEmbeddedLink.vue?vue&type=template&id=ec00d70a&scoped=true&"
import script from "./RomaEmbeddedLink.vue?vue&type=script&lang=js&"
export * from "./RomaEmbeddedLink.vue?vue&type=script&lang=js&"
import style0 from "./RomaEmbeddedLink.vue?vue&type=style&index=0&id=ec00d70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec00d70a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
